<template>
  <div
    class="wishcard-small"
    :class="{
      'wishcard-small--show-preview': hasImage, 
      'wishcard-small--has-error': hasErrors
    }"
  >
    <div class="wishcard-small__inner-left">
      <h4 
        class="wishcard-small__label"
        v-text="`${$t('wishcard.inner_side.left')}:`"
      />
      <div
        class="wishcard-small__image card-image"
        :style="imageStyles"
      />
    </div>      
    <div class="wishcard-small__inner-right">
      <h4
        class="wishcard-small__label"
        v-text="`${$t('wishcard.inner_side.right')}:`"
      />
      <tg-wishcard-textarea
        v-bind="$props"
        @validate="onValidate"
        :show-default-placeholder="false"
      />
    </div>       
  </div>    
</template>

<script>
import TgWishcardTextarea from './TgWishcardTextarea';

export default {
    name: 'TgWishcardSmall',

    components: {
      TgWishcardTextarea
    },

    data() {
      return {
        hasErrors: false
      }
    },

    props: {
      maxLength: {
        type: Number,
        required: false,
        default: 320
      },
      maxLines: {
        type: Number,
        required: false,
        default: 9
      },
      cardText: {
        type: String,
        required: true,
        default: ''
      },
      card: {
        type: [Object, null],
        required: true,
        default: null
      }
    },

    computed: {
      imageStyles() {
        const styles = {}
        if (this.hasImage) {
          styles['background-image'] = `url('${this.card.image}')`
        }
        return styles;
      },

      hasImage() {
        return this.card && this.card.image
      },
    },

    methods: {
      onValidate({ tooManyLines, tooManyCharacters }) {
        this.hasErrors = tooManyLines === true || tooManyCharacters === true;
      }
    }
}
</script>

<style scoped>
.wishcard-small {
  position: relative;
}

.wishcard-small__label {
  font-size: .875rem;
  font-weight: normal;
  font-style: italic;
  color: var(--text-color);
}

.wishcard-small__label,
.wishcard-small__image {
  display: none;
}

.wishcard-small__inner-left {
  margin-bottom: 1rem;
}

.wishcard-small--show-preview .wishcard-small__label,
.wishcard-small--show-preview .wishcard-small__image {
  display: block;
}

.wishcard-small__image,
.wishcard-small >>> .wishcard__field {
  position: relative;
  border-radius: var(--border-radius);
  background-color: var(--background-light);
  padding-top: 47.62% !important;
}

.wishcard-small__image {
  background-size: cover;
  background-repeat: no-repeat;
}

.wishcard-small >>> .wishcard__input {
  padding: 3.22% 4.03% 3.22% 11.29%;
}

.wishcard-small >>> .wishcard__placeholder {
  padding: 3.22% 0 0 11.29% !important;
}

.wishcard-small--has-error .wishcard-small__image:after,
.wishcard-small--has-error >>> .wishcard__field:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  z-index: 100;
  pointer-events: none;
}

.wishcard-small--has-error >>> .wishcard__field:after {
  border: 2px var(--danger) solid;
}

@media (min-width: 75rem) {
  .wishcard-small {
    display: flex;
  }

  .wishcard-small--has-error .wishcard-small__image,
  .wishcard-small--has-error >>> .wishcard__field {
    position: relative;
  }

  .wishcard-small--has-error .wishcard-small__image:after,
  .wishcard-small--has-error >>> .wishcard__field:after {
    border: 2px var(--danger) solid;
  }

  .wishcard-small--has-error .wishcard-small__image:after {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .wishcard-small--has-error >>> .wishcard__field:after {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .wishcard-small::before {
    content: '';
    width: 2px;
    height: 100%;
    display: block;
    background: #fff;
    position: absolute;
    inset: 0 0 0 50%;
    z-index: 100;
    transform: translateX(-1px);
  }

  .wishcard-small__label {
    display: none !important;
  }  

  .wishcard-small__inner-left,
  .wishcard-small__inner-right {
    width: 50%;
    margin: 0;
  }
  
  .wishcard-small__image {
    display: block;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  } 

  .wishcard-small >>> .wishcard__field {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>